import Tab from '@mui/material/Tab';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '../../../../constants/colors';

export interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export function projectTabsProps(index: number) {
    return {
        id: `project-tab-${index}`,
        'aria-controls': `project-tabpanel-${index}`,
    };
}

export const CustomTab = styled(Tab)(({ }) => ({
    borderRadius: '10px 10px 0 0',
    backgroundColor: 'inherit',
    color: colors.black,
    '&.Mui-selected': {
        backgroundColor: colors.tabColor,
        color: colors.white,
    },
}));

export function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`project-tabpanel-${index}`}
            aria-labelledby={`project-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ padding: "12px 12px" }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}
